import { Button } from "@/components/UI/Buttons/Button";
import MedicalReportPromptType from "@/data/interfaces/MedicalReportPromptType";
import { UploadResponse } from "@/services/medicalReportProtocolService";
import { FormEvent, useState } from "react";
import MedicalReportUploadCard from "./MedicalReportUploadCard";

interface MedicalReportUploadFormProps {
  types: MedicalReportPromptType[];
  onSubmit: (responses: Map<number, any>) => void;
}

const MedicalReportUploadForm = ({
  onSubmit,
  types,
}: MedicalReportUploadFormProps) => {
  const [responses, setResponses] = useState<Map<number, UploadResponse>>(
    new Map(),
  );

  const canSubmit = types.every((type) => responses.has(type.id));

  const handleUploadSuccess = (response: UploadResponse) => {
    setResponses((prev) => new Map(prev).set(response.type_id, response));
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit(responses);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-3 gap-4">
        {types.map((type) => (
          <MedicalReportUploadCard
            key={type.id}
            type={type}
            onUploadSuccess={handleUploadSuccess}
          />
        ))}
      </div>

      <Button type="submit" size="sm" className="mt-4" disabled={!canSubmit}>
        Show
      </Button>
    </form>
  );
};

export default MedicalReportUploadForm;
